module.exports = __webpack_public_path__ + "static/media/cefor.5d82d62e.png";